import { api } from 'utility';
import {

    getFinancialTransferUrlDetail,
} from 'URLs';

class transactionService {

    /**
     * دریافت لیست بابت تراکنش  
    */
    async getForTransaction(params) {
        return api.get(getFinancialTransferUrlDetail()).then((res) => res.data);
    }
}

export default new transactionService();
